// extracted by mini-css-extract-plugin
export default {"hr-line":"Contact_hr-line__gjBOm","custom-card":"Contact_custom-card__mabKd","h1-border__style":"Contact_h1-border__style__P1kyb"};